import { useState } from "react"

const usePagination = (defaultPage: number = 1, defaultPerPage: number = 50) => {
  const [page, setPage] = useState(defaultPage)
  const [perPage, setPerPage] = useState(defaultPerPage)

  return {
    page,
    setPage,
    perPage,
    setPerPage
  }
}

export default usePagination
